import React from 'react';
import SponsorLanding from '../components/Succeedo/Sponsorship/SponsorLanding';

const SucceedoSponsorLandingContainer = (props, _railsContext) => <SponsorLanding {...props} />;

export default SucceedoSponsorLandingContainer;
